// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__jXDC8","title":"style_title__20zvf","map":"style_map__1GenX"};